const BASE_API_KEY = "baseApi";
const EVENT_LIST_KEY_TAG = "eventList";
const eventListFavoriteId = "FAVORITE";
const eventListOtherId = "OTHER";
const customerAuthTokenName = "customer";
export {
  BASE_API_KEY,
  EVENT_LIST_KEY_TAG,
  customerAuthTokenName,
  eventListFavoriteId,
  eventListOtherId
};
